import { LeadForm } from "../components/LeadForm";
import { t } from "../i18n/t";
import { usePageTitle } from "../lib/usePageTitle";

/** `/kontakt`: public contact form for prospective customers. */
export function ContactPage() {
  usePageTitle(t("contact.title"));
  return (
    <div className="page narrow">
      <h1>{t("contact.title")}</h1>
      <p className="lead">{t("contact.lead")}</p>
      <LeadForm />
    </div>
  );
}
